import { message } from "ant-design-vue"
import { ref } from "vue"

import i18n from "@/i18n"
import syncService from "@/services/syncService"

export const useSyncSettings = () => {
  const isDeleteModalOpened = ref(false)
  const isStopModalOpened = ref(false)
  const startSyncRequestUuid = ref<string | null>(null)
  const currentSyncUuid = ref("")

  const handleOpenStopModal = (uuid: string) => {
    currentSyncUuid.value = uuid
    isStopModalOpened.value = true
  }

  const handleOpenDeleteModal = (uuid: string) => {
    currentSyncUuid.value = uuid
    isDeleteModalOpened.value = true
  }

  const handleCloseStopModal = () => {
    isStopModalOpened.value = false
    currentSyncUuid.value = ""
  }

  const handleCloseDeleteModal = () => {
    isDeleteModalOpened.value = false
    currentSyncUuid.value = ""
  }

  const handleStartSync = (uuid: string, callback: () => void) => {
    startSyncRequestUuid.value = uuid

    syncService
      .updateSynchronization({
        uuid,
        data: { is_active: true }
      })
      .then(() => syncService.triggerSynchronization(uuid))
      .then(() => {
        callback()
      })
      .catch(() => {
        message.error(i18n.t("synchronization.sync_not_updated") as string)
      })
      .finally(() => {
        startSyncRequestUuid.value = null
      })
  }

  return {
    isDeleteModalOpened,
    isStopModalOpened,
    startSyncRequestUuid,
    currentSyncUuid,
    handleOpenStopModal,
    handleOpenDeleteModal,
    handleCloseStopModal,
    handleCloseDeleteModal,
    handleStartSync
  }
}
